<script lang="ts">
    import { cart, removeCartItem, updateCartItem, validateCart } from "../lib/components/CartButton.svelte"
    import ProductConfigurator from "../lib/components/ProductConfigurator.svelte"
    import MedialibImage from "../lib/components/MedialibImage.svelte"
    import InView from "../lib/components/InView.svelte"
    import CartForm from "./CartForm.svelte"
    import { cryptchaSolution, cryptchaSolutionId, initCryptcha } from "../lib/utils"
    import { api } from "../api"

    validateCart()

    let submitSuccess = false

    if (typeof window !== "undefined")
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        })

    async function submitCart() {
        const isValid = await validateCart()
        if (isValid) {
            // submit cart
            const orderData: OrderData = {
                cart: $cart,
                contact: formData?.contact,
                shippingAddress: formData?.shippingAddress,
                billingAddress: formData?.billingAddress,
                _s: $cryptchaSolution,
                _sId: $cryptchaSolutionId,
            }

            try {
                await api(
                    "action",
                    {
                        method: "POST",
                        params: {
                            cmd: "submitOrder",
                        },
                    },
                    orderData
                )

                $cart = []

                submitSuccess = true
                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                })
            } catch (e) {
                console.error(e)
                alert("Submitting order failed, please contact our support.")
            }
        }
    }

    let formData: CartFormData
    let cryptchaEl: HTMLDivElement
    let cryptchaInitialized = false
    $: if (cryptchaEl && !cryptchaInitialized && formData?.shippingAddress?.firstName) {
        initCryptcha(cryptchaEl)
        cryptchaInitialized = true
    }

    $: console.log(formData)
</script>

<section class="product-cart gray-bg tp-xl bp-xl">
    <div class="container bp-xl">
        <h1 class="h2">Cart</h1>
    </div>
    {#if submitSuccess}
        <div class="container">
            <p>Your request has been submitted successfully.</p>
        </div>
    {:else if $cart?.length}
        <div class="container">
            <div class="cart-wrapper gap-m">
                {#each $cart || [] as cartItem}
                    <div class="cart-item white-bg border-radius-all border-radius-m">
                        <div class="grid">
                            {#if cartItem.product.externalData?.customAttributes?.length || cartItem.product.externalData.bomItems?.length || cartItem.product.externalData.properties?.sportidentIdRangeMax}
                                <ProductConfigurator
                                    product="{cartItem.product}"
                                    bind:productConfig="{cartItem.productConfig}"
                                    bind:bomItemConfigs="{cartItem.bomItemConfigs}"
                                    quantity="{cartItem.quantity}"
                                />
                            {:else}
                                <div class="col-12 col-md-auto">
                                    <div class="product-configurator-wrapper">
                                        <div class="grid align-center">
                                            <div class="col-sm-3">
                                                <div class="thumbnail">
                                                    <figure>
                                                        <InView>
                                                            <MedialibImage id="{cartItem.product.teaserimage}" />
                                                        </InView>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div class="col-auto">
                                                <div class="product-info">
                                                    <a href="/products/{cartItem.product.slug || cartItem.product.id}">
                                                        <span class="product-title h3">{cartItem.product.title}</span>
                                                    </a>
                                                    <div class="badge">
                                                        {#if cartItem.product.number}
                                                            <span>Art.-No. {cartItem.product.number}</span>
                                                        {/if}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            {/if}
                            <div class="col-12 col-xs-8 col-md-3" style="margin: 0 0 0 auto;">
                                <div class="col-grid align-end product-setup">
                                    <div class="col-12 col-bleed">
                                        <div class="grid align-center justify-center no-wrap form">
                                            <div class="col-auto justify-end">
                                                {#if !cartItem.product.externalData?.hasFixedQuantityOne}
                                                    <button
                                                        class="subtract-quantity"
                                                        on:click="{() =>
                                                            updateCartItem(cartItem, cartItem.quantity - 1)}">-</button
                                                    >
                                                {/if}
                                            </div>

                                            <div class="col-4ch border-bottom">
                                                <input
                                                    class="quantity"
                                                    value="{cartItem.quantity}"
                                                    type="number"
                                                    on:change="{(e) => {
                                                        updateCartItem(cartItem, parseInt(e.target.value))
                                                    }}"
                                                />
                                            </div>
                                            <div class="col-auto justify-start">
                                                {#if !cartItem.product.externalData?.hasFixedQuantityOne}
                                                    <button
                                                        class="add-quantity"
                                                        on:click="{() =>
                                                            updateCartItem(cartItem, cartItem.quantity + 1)}">+</button
                                                    >
                                                {/if}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-auto remove-button">
                                        <button class="cta btn-primary" on:click="{() => removeCartItem(cartItem)}"
                                            >Remove</button
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
        <div class="container">
            <CartForm submitHandler="{submitCart}" submitDisabled="{!$cryptchaSolution}" bind:formData />
            <div bind:this="{cryptchaEl}"></div>
        </div>
    {:else}
        <div class="container">
            <p>Your cart is empty.</p>
        </div>
    {/if}
</section>
